var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.64,
    height: 123.64,
    viewBox: "0 0 123.64 123.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.82,0a61.82,61.82,0,1,0,61.82,61.82A61.85,61.85,0,0,0,61.82,0Zm0,8.63A53.2,53.2,0,1,1,8.63,61.82,53.22,53.22,0,0,1,61.82,8.63Z",
    fill: "#ccc6f8",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.45,50.32a8.63,8.63,0,1,1-8.63-8.63,8.63,8.63,0,0,1,8.63,8.63",
    fill: "#ccc6f8",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.45,50.32a8.63,8.63,0,1,1-8.63-8.63,8.64,8.64,0,0,1,8.63,8.63",
    fill: "#ccc6f8",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.84,83.08,74.6,94.58a4.31,4.31,0,0,0,3.2-8L49.05,75.07a4.31,4.31,0,0,0-3.21,8Z",
    fill: "#ccc6f8",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeh);
export default __webpack_public_path__ + "static/media/meh.8358479e560882d1651d58717d1032ab.svg";
export { ForwardRef as ReactComponent };